import * as React from 'react'

import { ExternalSchool_externalSchool } from 'main/gql/externalSchool'
import { SchoolPage_school } from 'main/pages/School/gql'
import { Text, Title } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../i18n'

import { AdditionalInfoContainer, Container } from './Basics.styles'
import { ExternalBasics } from './ExternalBasics'
import InternalBasics from './InternalBasics'

const PRE = `${i18nKeyPrefix}-BASICS`

interface IProps {
  school: SchoolPage_school | ExternalSchool_externalSchool
}

export default function Basics(props: IProps) {
  const { school } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  if (!school.profile || !school) return null

  const additionalInfo =
    school.__typename === 'School' && school.profile ? school.profile.additionalInfo : null

  return (
    <Container>
      <Title kind="normal">{t(`${PRE}-TEXT`)}</Title>
      <Content {...props} />
      {additionalInfo && (
        <AdditionalInfoContainer>
          <Text muted>{additionalInfo}</Text>
        </AdditionalInfoContainer>
      )}
    </Container>
  )
}

function Content(props: IProps) {
  const { school } = props

  if (school.__typename === 'School' && school.profile) {
    return <InternalBasics school={school} />
  } else if (school.__typename === 'ExternalSchool') {
    return <ExternalBasics school={school} />
  } else return null
}
